module.exports = __webpack_public_path__ + "static/media/balance-pay.b0ccff59.png";